module.exports = __webpack_public_path__ + "static/media/samplefile.7feeb5c8.csv";


//////////////////
// WEBPACK FOOTER
// ./src/sample/samplefile.csv
// module id = 1363
// module chunks = 1